import { RootState } from 'store/root-reducer';

export const getAnalysisTransits = (state: RootState): any | null => state.wim.comparativeAnalysis.transits;

export const isLoading = (state: RootState): boolean => state.wim.comparativeAnalysis.isLoading;

export const isExportLoading = (state: RootState): boolean => state.wim.comparativeAnalysis.isExportLoading;

export const exportData = (state: RootState): any => state.wim.comparativeAnalysis.exportData;

export const getFilterValues = (state: RootState): any => state.wim.comparativeAnalysis.filterValues;
